import styled from 'styled-components';

export const Title = styled.div`
  font-size: 21px;
  padding-bottom: 10px;
  font-weight: 600;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
  line-height: 125%;
`;

export const HintsContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    &:not(:first-child) {
      padding-top: 4px;
    }
  }
`;

export const Hint = styled.span`
  font-size: 12px;
  line-height: 160%;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[2]};
`;

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTooltipWrapper = styled.div`
  margin-left: ${({ theme }): string => theme.spacers!.spacer01};
  font-size: 12px;
  line-height: 160%;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[2]};
`;
